import React from "react";
import Chart from "react-apexcharts";

const DoughnutChart = ({ data,themeMode }) => {
  const chartOptions = {
    chart: {
      type: "donut",
    },
    labels: data.map((item) => item.name),
    colors: [ "#1a2649", "#495dab"],
    legend: {
      position: "bottom",
      labels: {
        colors: themeMode === "dark" ? "#FFFFFF" : "#000000", // Legend text rengi
      },
    },
    stroke: {
      show: false, // Sınırları tamamen kaldırır
      width: 0,    // Sınır genişliğini sıfırlar
      colors: ["transparent"], // Sınır rengini şeffaf yapar
    },
  xaxis: {
      labels: {
          style: {
              colors: themeMode === "dark" ? "#FFFFFF" : "#000000",
          },
      },
  },
  yaxis: {
      labels: {
          style: {
              colors: themeMode === "dark" ? "#FFFFFF" : "#000000",
          },
      },
  },
  tooltip: {
      theme: themeMode === "dark" ? "dark" : "light",
  },
    tooltip: {
      y: {
        formatter: (val) => `${val}`,
      },
    },
  };

  const chartSeries = data.map((item) => item.value);

  return (
    <div>
      <Chart
        options={chartOptions}
        series={chartSeries}
        type="donut"
        width="90%"
        height={200}
      />
    </div>
  );
};

export default DoughnutChart;
